import { CircularProgress, Container, Grid, Paper, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { errorMessage } from '../../../util/ConfirmAlertUtil';
import { criaTransacaoCartaoCreditoLancamento } from '../api-lancamento';
import { currencyRound } from '../../../util/DoubleUtil';
import MasterCardImg from '../../../shared/assets/img/financeiro/cartao_credito/master-card.png';
import VisaCardImg from '../../../shared/assets/img/financeiro/cartao_credito/visa.png';
import HipercardImg from '../../../shared/assets/img/financeiro/cartao_credito/hipercard.png';
import Button from '../../UI/Button';
import ReactInputMask from 'react-input-mask';

const LancamentoPagamentoPorCreditoForm = ({ lancamento }) => {
    const [cartaoCreditoTransacao, setCartaoCreditoTransacao] = useState(null);
    const [isLoadingAction, setIsLoadingAction] = useState(false);

    const handleChange = (event) => {
        setCartaoCreditoTransacao({
            ...cartaoCreditoTransacao,
            [event.target.name]: event.target.value
        })
    }

    const clickSubmit = (event) => {
        event.preventDefault();
        setIsLoadingAction(true);
        criaTransacaoCartaoCreditoLancamento(lancamento.codigo, cartaoCreditoTransacao).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    toast.success("Salvo com sucesso.", {
                        position: toast.POSITION.BOTTOM_LEFT
                    });


                }
            }
            setIsLoadingAction(false);
        })
    }

    return (
        <Container component={Paper} maxWidth='sm'>
            <Grid item>
                <form onSubmit={clickSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant='body1' style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                Cartão de Crédito
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                        >
                            <Grid container direction='row'>
                                <Grid item xs={6}>

                                </Grid>
                                <Grid item>
                                    <img
                                        style={{
                                            height: '30px',
                                            width: '30px',
                                        }}
                                        src={MasterCardImg}
                                        alt=''
                                    />
                                    <img
                                        style={{
                                            height: '25px',
                                            width: '30px',
                                            marginLeft: '10px'
                                        }}
                                        src={VisaCardImg}
                                        alt=''
                                    />
                                    <img
                                        style={{
                                            height: '25px',
                                            width: '30px',
                                            marginLeft: '10px'
                                        }}
                                        src={HipercardImg}
                                        alt=''
                                    />
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid
                            item
                            xs={12}
                        >
                            <Grid container direction='row'>
                                <Grid item xs={6}>
                                    <Typography variant='body1'>
                                        Nome Impresso
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        name="nomeImpresso"
                                        placeholder='Nome Impresso'
                                        required
                                        autoFocus
                                        onChange={handleChange}
                                        value={cartaoCreditoTransacao && cartaoCreditoTransacao.nomeImpresso ? cartaoCreditoTransacao.nomeImpresso : ''}
                                    />
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid
                            item
                            xs={12}
                        >
                            <Grid container direction='row'>
                                <Grid item xs={6}>
                                    <Typography variant='body1'>
                                        Número Cartão
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <ReactInputMask
                                        mask="9999 9999 9999 9999"
                                        name="numeroCartao"
                                        placeholder='XXXX XXXX XXXX XXXX'
                                        onChange={handleChange}
                                        value={cartaoCreditoTransacao && cartaoCreditoTransacao.numeroCartao ? cartaoCreditoTransacao.numeroCartao : ''}
                                        maskchar="_"
                                    >
                                        <TextField
                                            required
                                            fullWidth

                                        />

                                    </ReactInputMask>

                                </Grid>
                            </Grid>

                        </Grid>

                        <Grid
                            item
                            xs={12}
                        >
                            <Grid container direction='row'>
                                <Grid item xs={6}>
                                    <Typography variant='body1'>
                                        Data Validade
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <ReactInputMask
                                        mask="99/9999"
                                        name="dataValidade"
                                        placeholder='MM/AAAA'
                                        onChange={handleChange}
                                        value={cartaoCreditoTransacao && cartaoCreditoTransacao.dataValidade ? cartaoCreditoTransacao.dataValidade : ''}
                                        maskchar="_"
                                    >
                                        <TextField
                                            required
                                            fullWidth

                                        />

                                    </ReactInputMask>

                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid
                            item
                            xs={12}
                        >
                            <Grid container direction='row'>
                                <Grid item xs={6}>
                                    <Typography variant='body1'>
                                        Código de Segurança
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <ReactInputMask
                                        mask="999"
                                        name="codigoSeguranca"
                                        placeholder='XXX'
                                        onChange={handleChange}
                                        value={cartaoCreditoTransacao && cartaoCreditoTransacao.codigoSeguranca ? cartaoCreditoTransacao.codigoSeguranca : ''}
                                        maskchar="_"
                                    >
                                        <TextField
                                            required
                                            fullWidth

                                        />

                                    </ReactInputMask>

                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid
                            item
                            xs={12}
                        >
                            <Grid container direction='row'>
                                <Grid item xs={6}>
                                    <Typography variant='body1'>
                                        Valor
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant='body1'>
                                        {lancamento && lancamento.valorReajustado ? "R$ " + currencyRound(lancamento.valorReajustado) : ''}
                                    </Typography>
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid
                            item
                            xs={12}
                        >
                            <Grid container direction='row'>
                                <Grid item xs={6}>
                                    <Typography variant='body1'>
                                        Quantidade Parcelas
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant='body1'>
                                        {lancamento && lancamento.quantFixaParcelas ? lancamento.quantFixaParcelas + "x - R$ " + currencyRound(lancamento.valorReajustado / lancamento.quantFixaParcelas) : ''}
                                    </Typography>
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid
                            item
                            xs={12}
                            style={{ marginTop: '30px' }}
                        >
                            <Grid container direction='row'>
                                <Grid item xs={6}>
                                    <Button
                                        disabled={isLoadingAction}
                                        type='submit'
                                    >
                                        {isLoadingAction && <CircularProgress color="primary" size={20} style={{ marginRight: '10px' }} />}
                                        Realizar Pagamento
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>

                                </Grid>
                            </Grid>

                        </Grid>

                    </Grid>
                </form>
            </Grid>
        </Container>
    )
}

export default LancamentoPagamentoPorCreditoForm;